import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from '../Echarts/Echarts';
import { Form, Select, Button, Tabs, Row, Col } from 'antd';
import StyledTable from '../../../../../commons/styles/table';

const { TabPane } = Tabs;

const Calibration = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const option = {
    xAxis: {
      type: 'category',
      data: [0.0, 0.15, 0.3, 0.45, 0.6, 0.75, 1.0]
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [2000, 3000, 4000, 5000, 6000, 7000],
        type: 'line'
      }
    ]
  };
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };
  const columns = [
    {
      title: translation('Name'),
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: translation('Sample Name'),
      dataIndex: 'age',
      key: 'age'
    },
    {
      title: translation('Date'),
      dataIndex: 'address',
      key: 'address'
    },
    {
      title: translation('STD Value'),
      dataIndex: 'address',
      key: 'address'
    }
  ];
  const dataSource = [{}, {}];

  const columns1 = [
    {
      title: translation('Item'),
      dataIndex: 'Item',
      key: 'Item'
    }
  ];

  const columns2 = [
    {
      title: translation('Standard Value'),
      dataIndex: 'No',
      key: 'No'
    }
  ];
  const dataSource1 = [{}, {}];

  return (
    <div>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('HeaderNumber_current')}
        style={{ backgroundColor: 'rgb(215, 231, 240)', margin: '19px 0px', padding: '30px' }}
      >
        <Form.Item label="HD">
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <Button type="primary">{translation('Connection')}</Button>
        </Form.Item>
      </Form>

      <Form
        {...formItemLayout}
        layout="horizontal"
        name="HeaderNumber_current"
        className="formComponent"
      >
        <Tabs defaultActiveKey="1" type="card">
          <TabPane tab={translation('Calibration Data')} key={'CD'}>
            <div>
              <Row>
                <Col flex="auto">
                  <StyledTable size="small"
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    bordered
                  />
                </Col>
              </Row>
            </div>
          </TabPane>
          <TabPane tab={translation('Calibration Result')} key={'CR'}>
            <Form.Item label="Number of Recommended Factor">
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>
            <div
              style={{ margin: '19px', padding: '30px' }}
            >
              <StyledTable size="small" dataSource={dataSource1} columns={columns1} pagination={false} bordered />
            </div>
            <div
              style={{ margin: '19px', padding: '30px' }}
            >
              <StyledTable size="small" dataSource={dataSource1} columns={columns2} pagination={false} bordered />
            </div>
          </TabPane>
          <TabPane tab={translation('Calibration Graph')} key={'CG'}>
            <Form.Item label="Factor Select Recommended">
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>

            <Row>
              <Col flex={3}>
                <Form
                  {...formItemLayout}
                  layout="horizontal"
                  name={translation('form1')}
                  style={{
                    margin: '19px',
                    padding: '30px'
                  }}
                  className="formComponent"
                >
                  <Form.Item label={translation('Coefficient')}>
                    <div>R -</div>
                  </Form.Item>
                  <Form.Item label={translation('Standard Error')}>
                    <div>SEC -</div>
                  </Form.Item>
                  <Form.Item label={translation('Number Of Samples')}>
                    <div>N -</div>
                  </Form.Item>
                  <Form.Item label={translation('Sample County Count')}>
                    <div>GN -</div>
                  </Form.Item>
                </Form>
              </Col>
              <Col flex={3}>
                <Form
                  {...formItemLayout}
                  layout="horizontal"
                  name={translation('form2')}
                  style={{
                    margin: '19px',
                    padding: '30px'
                  }}
                  className="formComponent"
                >
                  <Form.Item label={translation('No')}>
                    <Select style={{ width: 220 }}>
                      <Select.Option value="01">01</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label={translation('Standard Value')}></Form.Item>
                  <Form.Item label={translation('Predicted Value')}></Form.Item>
                  <Form.Item label={translation('Residual Error')}></Form.Item>
                </Form>
              </Col>
            </Row>
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              style={{ margin: '19px', padding: '30px' }}
              className="react_for_echarts"
            />
            <Button type="primary" style={{ margin: '10px' }}>
              {translation('Write By KB-30')}
            </Button>
          </TabPane>
        </Tabs>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Calibration);
